import React from 'react'
import { ReactTyped } from "react-typed";
import myBackground  from '../assets/sprout.png'
const Hero = () => {
  return (
    <div className="w-screen h-screen bg-cover bg-center" style={{ backgroundImage: `url(${myBackground})` }}>
      <div className='text-white'>
          <div className='max-w-[1024px] w-full h-screen mx-auto text-center flex flex-col justify-start my-10'>
              <p className='bg-gradient-to-r from-white via-yellow-500 to-orange-600 inline-block text-transparent bg-clip-text text-xl font-extrabold p-2 mt-40'>Free Storage Up To 10GB and Free Hosting</p>
              {/* <p className='text-yellow-500 text-xl font-extrabold p-2'>Free Storage Up To 10GB and Free Hosting</p> */}
              <h1 className='md:text-7xl sm:text-6xl text-4xl font-bold md:py-6'>Secure File Sharing</h1>
              <div className='flex justify-center items-center'>
                  <p className='md:text-5xl sm:text-4xl text-xl font-bold text-yellow-500'>Powered by</p>
                  <ReactTyped className='md:text-5xl sm:text-4xl text-xl font-extrabold md:pl-4 pl-2 text-indigo-200' strings={[
                    "Cloudflare R2 Storage",
                    "Cloudflare Worker",
                    "Cloudflare Page",
                    "Node JS",
                    "React JS",
                    "Tailwind CSS",
                    "ChatGPT"
                  ]} typeSpeed={120} 
                      backSpeed={130} 
                      backDelay={3000}
                      loop 
                  />
              </div>
              <p className='md:text-2xl text-xl font-bold text-white mt-4'>100% Ad Free Open Source Development</p>
          </div>
      </div>
    </div>
  )
}

export default Hero